import React from "react";
import { useNavigate } from "react-router-dom";

import LogoutButton from "./LogoutButton";

type Props = {
  className?: string;
};

const AccountActions: React.FC<Props> = ({ className }) => {
  const navigate = useNavigate();

  return (
    <div className={`account-actions ${className ?? ""}`.trim()}>
      <button
        type="button"
        className="app-button secondary small"
        onClick={() => navigate("/change-password")}
      >
        Change Password
      </button>
      <LogoutButton />
    </div>
  );
};

export default AccountActions;
